import { render, staticRenderFns } from "./personRegisterView.vue?vue&type=template&id=71cfbf02&scoped=true"
import script from "./personRegisterView.vue?vue&type=script&lang=js"
export * from "./personRegisterView.vue?vue&type=script&lang=js"
import style0 from "./personRegisterView.vue?vue&type=style&index=0&id=71cfbf02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfbf02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cfbf02')) {
      api.createRecord('71cfbf02', component.options)
    } else {
      api.reload('71cfbf02', component.options)
    }
    module.hot.accept("./personRegisterView.vue?vue&type=template&id=71cfbf02&scoped=true", function () {
      api.rerender('71cfbf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/personRegister/personRegisterView.vue"
export default component.exports